export default "__VITE_ASSET__CS10eA4o__"